module.exports = __webpack_public_path__ + "static/media/act02.928eb9cd.mpeg";